module.exports = __webpack_public_path__ + "static/media/  (45).1d059cf0.jpg";